export default [
	{
		path: "/activity/sign/login",
		name: "ActivitySignLogin",
		component: () => import("../../views/activity/sign/login.vue"),
		meta: {
			title: "登录",
		},
	},
	{
		path: "/activity/sign/about",
		name: "ActivitySignAbout",
		component: () => import("../../views/activity/sign/about.vue"),
		meta: {
			title: "加载中...",
		},
	},
	{
		path: "/activity/sign/audit",
		name: "ActivitySignAudit",
		component: () => import("../../views/activity/sign/audit.vue"),
		meta: {
			title: "加载中...",
		},
	},
	{
		path: "/activity/sign/real-name",
		name: "ActivitySignRealName",
		component: () => import("../../views/activity/sign/real-name.vue"),
		meta: {
			title: "实名认证",
		},
	},
	{
		path: "/activity/sign/signature",
		name: "ActivitySignSignature",
		component: () => import("../../views/activity/sign/signature.vue"),
		meta: {
			title: "请在下方空白处签字，不可连笔，以便后续审核",
		},
	},
	{
		path: "/activity/sign/audit-result",
		name: "ActivitySignAuditResult",
		component: () => import("../../views/activity/sign/result.vue"),
		meta: {
			title: "审核结果",
		},
	},
];
